import { buildSuccessAttemptPayload } from './helpers/buildSuccessAttemptPayload.js';
export const trackEmailAttemptSuccessfulRequest = (params) => {
    return buildSuccessAttemptPayload({ ...params, loginMethod: 'standard' });
};
//# sourceMappingURL=trackEmailAttemptSuccessfulRequest.js.map